import { useI18n } from '@change-corgi/core-react/i18n';

import { validateAmount as validateAmountUtil } from '#src/app/shared/utils/payments';

import { usePromoteFormData } from '../../../../../formContext/formData';
import { usePromoteFormState } from '../../../../../formContext/formState';

type Result = Record<string, string> | EmptyObject;

export function useValidateAmount(): () => Result {
	const { typedTranslate, localizeCurrency } = useI18n();
	const {
		promotionCountrySettings: { maximumAmount, minimumAmount },
		currency,
	} = usePromoteFormData();
	const [{ amount }] = usePromoteFormState();

	return function validateAmount(): Result {
		// Note: formData amounts are objects with { amount, localizedAmount }, extract the amount value
		const maxAmount = maximumAmount?.amount;
		const minAmount = minimumAmount?.amount;
		const amountValidationI18nKey = validateAmountUtil({ amount, maximumAmount: maxAmount, minimumAmount: minAmount });
		if (!amountValidationI18nKey) return {};

		const amountError = typedTranslate(amountValidationI18nKey, {
			...(minAmount && {
				minimumAmount: localizeCurrency(minAmount, currency.code, {
					currencyDisplay: 'narrowSymbol',
					amountInBaseUnits: false,
				}),
			}),
			...(maxAmount && {
				maximumAmount: localizeCurrency(maxAmount, currency.code, {
					currencyDisplay: 'narrowSymbol',
					amountInBaseUnits: false,
				}),
			}),
		});
		return {
			amount: amountError,
			...(amount === 0 ? { amountSelection: amountError } : { customAmount: amountError }),
		};
	};
}
